import React, { useState } from 'react'
import { Icon } from "@iconify/react/dist/iconify.js";
import { Link } from "react-router-dom";
import { useAuth } from "../auth/AuthProvider";

export default function DropdownProfile() {
    const auth = useAuth();
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);

    const toggleDropdown = () => {
        setIsDropdownOpen(!isDropdownOpen);
    };

    const handleMouseEnter = () => {
        setIsDropdownOpen(true);
    };

    const handleMouseLeave = () => {
        setIsDropdownOpen(false);
    };
    return (
        <div className="dropdown position-relative" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
            <button
            className="d-flex justify-content-center align-items-center rounded-circle"
            type="button"
            onClick={toggleDropdown}
            >
            <img
                src={`${process.env.PUBLIC_URL}/assets/images/user.webp`}
                alt="image_user"
                className="w-40-px h-40-px object-fit-cover rounded-circle"
            />
            </button>
            <div className={`dropdown-menu dropdown-menu-end to-top dropdown-menu-sm ${isDropdownOpen ? 'show' : ''}`} 
                style={{ 
                    position: 'absolute',
                    right: '0',
                    top: '100%',
                    transform: 'none',
                    marginTop: '0.5rem',
                    maxHeight: '80vh',
                    overflowY: 'auto'
                }}>
            <div className="py-12 px-16 radius-8 bg-primary-50 mb-16 d-flex align-items-center justify-content-between gap-2">
                <div>
                <h6 className="text-lg text-primary-light fw-semibold mb-2">
                    {auth.user.nombre} {auth.user.apellido_paterno} {auth.user.apellido_materno}
                </h6>
                {/* <span className="text-secondary-light fw-medium text-sm">Admin</span> */}
                </div>
                {/* <button type="button" className="hover-text-danger">
                <Icon icon="radix-icons:cross-1" className="icon text-xl" />
                </button> */}
            </div>
            <ul className="to-top-list">
                {/* <li>
                <Link
                    className="dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-primary d-flex align-items-center gap-3"
                    to="#"
                >
                    <Icon icon="solar:user-linear" className="icon text-xl" /> My
                    Profile
                </Link>
                </li>
                <li>
                <Link
                    className="dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-primary d-flex align-items-center gap-3"
                    to="#"
                >
                    <Icon icon="tabler:message-check" className="icon text-xl" />{" "}
                    Inbox
                </Link>
                </li>
                <li>
                <Link
                    className="dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-primary d-flex align-items-center gap-3"
                    to="#"
                >
                    <Icon
                    icon="icon-park-outline:setting-two"
                    className="icon text-xl"
                    />
                    Setting
                </Link>
                </li> */}
                <li>
                <Link
                    className="dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-primary d-flex align-items-center gap-3"
                    to="/cambiar-contrasena"
                >
                    <Icon icon="lucide:lock" className="icon text-xl" /> Cambiar Contraseña
                </Link>
                </li>
                <li>
                <Link
                    className="dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-danger d-flex align-items-center gap-3"
                    // to="/cerrar_sesion"
                    onClick={
                        () => {
                            fetch('/cerrar_sesion',{
                                method: 'POST',
                                headers: {'Content-Type': 'application/json'}
                            })
                            .then(res => res.json())
                            .then(data => {
                                if(data.status === 1){
                                    window.location.href = '/login'
                                }
                            })
                        }
                    }
                >
                    <Icon icon="lucide:power" className="icon text-xl" /> Cerrar Sesión
                </Link>
                </li>
            </ul>
            </div>
        </div>
    )
}
